import { render, staticRenderFns } from "./Import-offer.vue?vue&type=template&id=75b31a48&"
import script from "./Import-offer.vue?vue&type=script&lang=ts&"
export * from "./Import-offer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Import-offer.vue"
export default component.exports